export class ShareContentToPublicParams {
  constructor(public PhysicalAddress: string, public Handler: string, public IsAllowed: boolean) {}
}
